import axios from "axios";

const base_url = process.env.REACT_APP_BASE_URL;

let bearer = localStorage.getItem("bearer");

const _axios = axios.create({withCredentials: true});

const post = async function (url, params, setProgress, signal) {

    const config = {
        onUploadProgress:
            setProgress
                ? function (progressEvent) {
                    setProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total))
                }
                : undefined,
        withCredentials: true,
        headers: {
            Authorization: bearer
        },
        signal: signal
    }

    try {
        return (await _axios.post(base_url + url, params, config)).data;
    } catch (error) {
        throw (error.response && error.response.data) || error;
    }
};

const get = async function (url, params, options = {}, headers = {}) {
    headers["Authorization"] = bearer;
    try {
        return (await _axios.get(base_url + url, {...options, headers, withCredentials: true, params}));
    } catch (error) {
        throw (error.response && error.response.data) || error;
    }
};

const download = async function (url, params, options = {}, headers = {}) {
    headers["Authorization"] = bearer;
    _axios.get(base_url + url, {...options, headers, withCredentials: true, params, responseType: "blob"}).then((data) => {
        console.log(data)
        const url = window.URL.createObjectURL(data.data);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', data.headers["content-disposition"]?.split("filename=")[1] || "file");
        document.body.appendChild(link);
        link.click();
        link.remove();

    }).catch((error) => {
        alert(error)
    });
};

const fetch_session_data = async () => {
    let res;
    if (bearer) {
        res = await get("/session/data");
    } else {
        res = await axios.get(`${base_url}/session/data`);
        bearer = res.headers["authorization"];
        if (bearer) localStorage.setItem("bearer", bearer);
    }
    return res.data;
}

export {
    fetch_session_data,
    get,
    post,
    bearer,
    download
}
